module.exports = __webpack_public_path__ + "static/media/g13.dc45a37a.jpeg";